import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import configData from "../../config/config.json";

export default function LoginPageSlidesSmall({ bare }) {
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);
  const [maxHeight, setMaxHeight] = useState(320);

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const currentSlideRef = useRef(null);

  useEffect(() => {
    const loadSlides = async () => {
      try {
        const response = await axios.get(
          configData.BROWSER_ROUTER_BASENAME +
            "/counties/" +
            configData.COUNTY_DIRECTORY +
            "/loginPageSlidesMobile.json"
        );

        setSlides(response.data);
      } catch (error) {
        console.error("Failed to load slides:", error);
      }
    };

    loadSlides();
  }, []);

  // Measure the actual rendered slide
  useEffect(() => {
    if (!currentSlideRef.current) return;

    const frame = requestAnimationFrame(() => {
      if (!currentSlideRef.current) return;

      const height = currentSlideRef.current.scrollHeight;

      setMaxHeight((prev) => Math.max(prev, height));
    });

    return () => cancelAnimationFrame(frame);
  }, [current, slides]);

  const nextSlide = () => {
    if (slides.length <= 1) return;

    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    if (slides.length <= 1) return;

    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const handleTouchStart = (e) => {
    if (slides.length <= 1) return;

    touchStartX.current = e.touches[0].clientX;
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    if (slides.length <= 1) return;

    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (slides.length <= 1) return;

    const distance = touchStartX.current - touchEndX.current;

    if (distance > 50) {
      nextSlide();
    } else if (distance < -50) {
      prevSlide();
    }
  };

  if (slides.length === 0) {
    return (
      <div style={bare ? styles.bareContainer : styles.container}>
        <div style={styles.loading}>Loading slides...</div>
      </div>
    );
  }

  const currentSlide = slides[current];

  return (
    <div style={bare ? styles.bareContainer : styles.container}>
       {!bare && <div style={styles.topAccent} />}
      <div
        ref={currentSlideRef}
        style={{
          ...styles.slide,
          minHeight: `${maxHeight}px`,
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {currentSlide.title && (
          <h2 style={styles.title}>{currentSlide.title}</h2>
        )}

        {currentSlide.paragraphs.map((item, index) => (
          <div key={index} style={styles.paragraphBlock}>
            {item.heading && (
              <h4 style={styles.heading}>{item.heading}</h4>
            )}

            <p style={styles.text}>{item.text}</p>
          </div>
        ))}
      </div>

      {slides.length > 1 && (
        <div style={styles.controls}>
          <button onClick={prevSlide} style={styles.arrow} aria-label="Previous slide">
            ‹
          </button>

          <div style={styles.counter}>
            {current + 1} / {slides.length}
          </div>

          <button onClick={nextSlide} style={styles.arrow}   aria-label="Next slide">
            ›
          </button>
        </div>
      )}
    </div>
  );
}

const styles = {
container: {
  maxWidth: "400px",
  margin: "20px auto",
  border: "1px solid #114E6B",
  borderRadius: "8px",
  backgroundColor: "#FAFCFD",
boxShadow: "0 4px 12px rgba(17, 78, 107, 0.12)",
  padding: "16px",
  textAlign: "left",
  display: "flex",
  flexDirection: "column",
  gap: "12px",
},

bareContainer: {
  textAlign: "left",
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  padding: "12px",
},

  loading: {
    textAlign: "center",
    color: "#666",
    padding: "20px 0",
  },

  slide: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },

  title: {
    fontSize: "18px",
    margin: "0 0 12px 0",
    fontWeight: "700",
    color: "#114E6B",
  },

paragraphBlock: {
  marginBottom: "20px",
},

  heading: {
    margin: "0 0 4px 0",
    fontSize: "15px",
    fontWeight: "700",
    color: "#114E6B",
  },

  text: {
    margin: 0,
    fontSize: "14px",
    color: "#555",
    lineHeight: "1.5",
  },

  controls: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "0px",
  },

  counter: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#114E6B",
  },

  arrow: {
    background: "none",
    border: "none",
    fontSize: "24px",
    cursor: "pointer",
    color: "#114E6B",
    padding: "4px 8px",
  },
  topAccent: {
  height: "8px",
  margin: "-16px -16px 0 -16px",
  borderTopLeftRadius: "8px",
  borderTopRightRadius: "8px",
background:
  "linear-gradient(90deg, #114E6B 0%, #2A6E8B 50%, #114E6B 100%)",
},
};